import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { throttle } from '@/utils/index';

// 页面限流组件
export default {
  name: 'LimitPage',
  data: function data() {
    return {
      timerId: null,
      leftSeconds: 0
    };
  },
  props: {
    limitCount: {
      type: Number,
      default: 0
    },
    backgroundImage: {
      type: String,
      default: ''
    },
    hasCountTime: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    defaultLimitTime: {
      type: Number,
      default: 0
    },
    showMask: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    limitCount: 'startTimer'
  },
  created: function created() {
    this.refresh = throttle(this.refresh.bind(this), 500);
    this.startTimer();
  },
  destroyed: function destroyed() {
    this.clearTimer();
  },
  methods: {
    startTimer: function startTimer() {
      var _this = this;
      this.clearTimer();
      if (!this.hasCountTime) return;
      this.leftSeconds = this.defaultLimitTime;
      this.timerId = setInterval(function () {
        _this.leftSeconds = _this.leftSeconds - 1;
        if (_this.leftSeconds <= 0) {
          _this.clearTimer();
        }
      }, 1000);
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
    },
    refresh: function refresh() {
      if (this.hasCountTime) {
        if (this.leftSeconds <= 0) {
          this.startTimer();
          this.$emit('refreshEvent');
        }
      } else {
        this.$emit('refreshEvent');
      }
    }
  }
};